import { useNavigation } from '@react-navigation/native';
import { PieChart } from 'lucide-react-native';
import React from 'react';
import type { StyleProp, ViewStyle } from 'react-native';
import { Pressable, Text } from 'react-native';

import { styles } from './styles';

type DashboardItemType = {
  style?: StyleProp<ViewStyle>;
  isSelected?: boolean;
};

export function DashboardItem({ style, isSelected }: DashboardItemType) {
  const navigation = useNavigation();
  const iconColor = isSelected ? styles.selectedIcon : styles.notSelectedIcon;

  return (
    <Pressable
      style={[styles.buttonContainer, style]}
      onPress={() => navigation.navigate('dashboard')}
    >
      <PieChart style={{ ...styles.icon, ...iconColor }} />
      <Text style={[styles.buttonText, style]}>Dashboard</Text>
    </Pressable>
  );
}
